import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#060D1B] flex items-center justify-center px-6 pt-28 pb-16">
      <div className="max-w-md text-center space-y-5">
        <p className="text-[#D4AF37] text-sm uppercase tracking-widest">Error 404</p>
        <h1 className="text-white text-2xl font-semibold">Esta página no existe</h1>
        <p className="text-white/60 text-sm">Puede que el enlace esté mal escrito o que la página se haya movido.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="inline-flex items-center justify-center bg-[#D4AF37] text-[#0F172A] font-semibold px-5 h-11">Ir al inicio</Link>
          <Link to="/dashboard" className="inline-flex items-center justify-center border border-white/25 text-white px-5 h-11">Área de miembros</Link>
        </div>
      </div>
    </div>
  );
}
